module.exports = "<div>\n    <md-toolbar>\n          <div class=\"md-toolbar-tools\">\n            <p>Resources Sample App</p>\n            <span flex></span>\n          </div>\n    </md-toolbar>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/common/navbar/navbar.html
// module id = 380
// module chunks = 0